module.exports = __webpack_public_path__ + "img/sec1.7b10525c.png";